import { useContext } from 'react';
import { AppContext } from '../context/appContext';

/**
 * Custom hook to access language context
 * @returns {object} Language context with all language-related functions
 */
const useLanguage = () => {
  const context = useContext(AppContext);

  if (!context) {
    throw new Error('useLanguage must be used within AppContextProvider');
  }

  return {
    language: context.language,
    setLanguage: context.setLanguage,
    t: context.t,
    formatNum: context.formatNum,
    formatDateStr: context.formatDateStr,
    formatDateTimeStr: context.formatDateTimeStr,
    formatLongDateStr: context.formatLongDateStr,
    isRTL: context.isRTL
  };
};

export default useLanguage;
